export default "__VITE_ASSET__CJmj9H6V__"